import { render, staticRenderFns } from "./editGroupModal.vue?vue&type=template&id=2f64def6&"
import script from "./editGroupModal.vue?vue&type=script&lang=ts&"
export * from "./editGroupModal.vue?vue&type=script&lang=ts&"
import style0 from "./editGroupModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports